import Repository from './Repository'

const resource = 'executions'

export default {
  getExecutions (eventId) {
    return Repository.get(`events/${eventId}/${resource}`, {
      params: {
        'include[0]': 'horse',
        'include[1]': 'rider',
        'include[3]': 'lesson',
        'include[4]': 'status',
        'include[5]': 'resultExecution',
        'include[6]': 'judgesExecutions.judge',
        'include[7]': 'judgesExecutions.secretary'
      }
    })
  },
  createExecution (eventId, data) {
    return Repository.post(`events/${eventId}/${resource}`, data)
  },
  updateExecution (eventId, executionId, data) {
    return Repository.patch(`events/${eventId}/${resource}/${executionId}`, data)
  },
  finishJudgeExecution (executionId, judgeId, data) {
    return Repository.post(`${resource}/${executionId}/judges/${judgeId}/process-results`, data)
  },
  updateJudgeExecution (executionId, judgeExecutionId, data) {
    return Repository.patch(`${resource}/${executionId}/judges-executions/${judgeExecutionId}`, data)
  },
  deleteExecution (eventId, executionId) {
    return Repository.delete(`events/${eventId}/${resource}/${executionId}`)
  },
  deleteExecutionData (eventId, executionId) {
    return Repository.delete(`events/${eventId}/${resource}/${executionId}/data`)
  },
  deleteJudgeExecution (executionId, judgeExecutionId) {
    return Repository.delete(`${resource}/${executionId}/judges-executions/${judgeExecutionId}`)
  },
  createJudgeExecutionList (executionId, data) {
    return Repository.post(`${resource}/${executionId}/judges-executions-list`, data)
  },
  getResultSummary (executionId, params) {
    return Repository.get(`${resource}/${executionId}/results-summary`, { params: params })
  },
  getJudgesResultsExecutions (executionId, params) {
    return Repository.get(`${resource}/${executionId}/judges-results-executions`, { params: params })
  },
  getJudgesResultsExercises (executionId, params) {
    return Repository.get(`${resource}/${executionId}/judges-results-exercises`, { params: params })
  },
  saveJudgesResultsExercises (executionId, data) {
    return Repository.post(`${resource}/${executionId}/judges-results-exercises`, data)
  },
  updateJudgesResultsExercisesList (executionId, judgeId, data) {
    return Repository.post(`${resource}/${executionId}/judges/${judgeId}/judges-results-exercises-list `, data)
  },
  updateJudgeResultExecution (executionId, resultExecutionId, data) {
    return Repository.patch(`${resource}/${executionId}/judges-results-executions/${resultExecutionId}`, data)
  },
  getJudgesInresults (executionId, params) {
    return Repository.get(`${resource}/${executionId}/judges-in-results`, { params: params })
  },
  getExecution (eventId, executionId) {
    return Repository.get(`events/${eventId}/${resource}/${executionId}`, {
      params: {
        'include[0]': 'horse',
        'include[1]': 'rider',
        'include[3]': 'lesson',
        'include[4]': 'status',
        'include[5]': 'resultExecution',
        'include[6]': 'judgesExecutions.judge',
        'include[7]': 'judgesExecutions.secretary'
      }
    })
  },
  downloadBinomios (eventId) {
    return Repository.get(`exports/events/${eventId}/${resource}/pdf`, {
      responseType: 'blob'
    })
  },
  downloadExecutionResults (executionId) {
    return Repository.get(`exports/${resource}/${executionId}/results/pdf`, {
      responseType: 'blob'
    })
  }
}
